import axios from './index'

export default {
  table(params) {
    return axios.get('/api/v1/place', { params })
  },
  spaces(params) {
    return axios.get('/api/v1/place/spaces', { params })
  },
}